// IMPORT REACT
import React from 'react';

// IMPORT STYLES
import { SC_ButtonSubmit } from '../styles';


const YASubmit = (props) => {    
    return (
    	<SC_ButtonSubmit {...props} type="submit" className={['btn-' + props.color, props.bootstrap, 'btn-' + props.size]} />
    )
    
}
export default YASubmit;